(() => {
  const description = document.querySelector('[data-rdr21-description-links]');
  const channelSuffix = description?.dataset.rdr21DescriptionLinks;
  const supportedChannels = new Set(['-billiger-de', '-guenstiger-de', '-heureka-sk']);
  if (!description || !supportedChannels.has(channelSuffix)) return;

  const knownSuffixPattern = /-(?:billiger-de|guenstiger-de|heureka-sk|pepita-de)$/;
  const productCache = new Map();
  const allowedHosts = new Set(['rdrsoftware.de', 'www.rdrsoftware.de', window.location.hostname]);

  const getProduct = (handle, routePrefix) => {
    const cacheKey = `${routePrefix}${handle}`;
    if (!productCache.has(cacheKey)) {
      const endpoint = new URL(`${routePrefix}products/${encodeURIComponent(handle)}.js`, window.location.origin);
      const request = fetch(endpoint.href, { headers: { Accept: 'application/json' }, cache: 'no-cache' })
        .then((response) => {
          if (!response.ok) throw new Error('Product unavailable in this channel.');
          return response.json();
        })
        .then((product) => {
          if (product.handle !== handle || !Array.isArray(product.variants)) throw new Error('Unexpected product response.');
          return product;
        });
      productCache.set(cacheKey, request);
    }
    return productCache.get(cacheKey);
  };

  const optionKey = (variant) => [variant.option1, variant.option2, variant.option3]
    .map((value) => value || '')
    .join('\u001f');

  const mappedVariantId = async (sourceHandle, targetHandle, variantId, routePrefix) => {
    const [sourceProduct, targetProduct] = await Promise.all([
      getProduct(sourceHandle, routePrefix),
      getProduct(targetHandle, routePrefix),
    ]);
    const sourceVariant = sourceProduct.variants.find((variant) => String(variant.id) === variantId);
    if (!sourceVariant) throw new Error('Source variant not found.');

    let matches = targetProduct.variants.filter((variant) => optionKey(variant) === optionKey(sourceVariant));
    if (matches.length !== 1 && sourceVariant.title) {
      matches = targetProduct.variants.filter((variant) => variant.title === sourceVariant.title);
    }
    if (matches.length !== 1 && sourceProduct.variants.length === 1 && targetProduct.variants.length === 1) {
      matches = targetProduct.variants;
    }
    if (matches.length !== 1) throw new Error('Matching channel variant not found.');
    return String(matches[0].id);
  };

  const repairLink = async (anchor) => {
    if (anchor.dataset.rdr21ChannelLinkState) return;
    const rawHref = anchor.getAttribute('href');
    if (!rawHref) return;

    let sourceUrl;
    try {
      sourceUrl = new URL(rawHref, window.location.origin);
    } catch {
      return;
    }
    if (!allowedHosts.has(sourceUrl.hostname)) return;

    const pathMatch = sourceUrl.pathname.match(/^(.*?\/)?products\/([^/]+)\/?$/);
    if (!pathMatch) return;

    const routePrefix = pathMatch[1] || '/';
    const sourceHandle = decodeURIComponent(pathMatch[2]);
    const baseHandle = sourceHandle.replace(knownSuffixPattern, '');
    const targetHandle = `${baseHandle}${channelSuffix}`;
    if (targetHandle === sourceHandle) {
      anchor.dataset.rdr21ChannelLinkState = 'resolved';
      return;
    }

    anchor.dataset.rdr21ChannelLinkState = 'pending';
    anchor.setAttribute('aria-disabled', 'true');
    anchor.removeAttribute('href');
    try {
      const targetProduct = await getProduct(targetHandle, routePrefix);
      const targetUrl = new URL(sourceUrl.href);
      targetUrl.protocol = window.location.protocol;
      targetUrl.host = window.location.host;
      targetUrl.pathname = `${routePrefix}products/${encodeURIComponent(targetHandle)}`;

      const sourceVariantId = sourceUrl.searchParams.get('variant');
      if (sourceVariantId) {
        const cloneVariantId = await mappedVariantId(sourceHandle, targetHandle, sourceVariantId, routePrefix);
        targetUrl.searchParams.set('variant', cloneVariantId);
      }

      const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewThemeId && !targetUrl.searchParams.has('preview_theme_id')) {
        targetUrl.searchParams.set('preview_theme_id', previewThemeId);
      }
      if (!description.contains(anchor)) return;
      anchor.href = targetUrl.href;
      anchor.dataset.rdr21ChannelLinkState = 'resolved';
      anchor.removeAttribute('aria-disabled');
    } catch {
      if (!description.contains(anchor)) return;
      anchor.dataset.rdr21ChannelLinkState = 'unavailable';
      anchor.setAttribute('aria-disabled', 'true');
    }
  };

  const repairDescriptionLinks = (root = description) => {
    root.querySelectorAll('a[href]').forEach((anchor) => {
      repairLink(anchor);
    });
  };

  repairDescriptionLinks();
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches('a[href]')) repairLink(node);
        repairDescriptionLinks(node);
      });
    });
  }).observe(description, { childList: true, subtree: true });
})();
